import { render, staticRenderFns } from "./weeklyNarrativeView.vue?vue&type=template&id=19b33aae&scoped=true&"
import script from "./weeklyNarrativeView.vue?vue&type=script&lang=js&"
export * from "./weeklyNarrativeView.vue?vue&type=script&lang=js&"
import style0 from "./weeklyNarrativeView.vue?vue&type=style&index=0&id=19b33aae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b33aae",
  null
  
)

export default component.exports